function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedEmployer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Employer Icon",
    d: "M4.667 9.333A.667.667 0 0 1 4 10h-.667a.667.667 0 1 1 0-1.333H4a.667.667 0 0 1 .667.666zm2.667-.667h-.667a.667.667 0 1 0 0 1.333h.667a.667.667 0 0 0 0-1.333zM4 11.333h-.667a.667.667 0 1 0 0 1.333H4a.667.667 0 1 0 0-1.333zm3.333 0h-.666a.667.667 0 1 0 0 1.333h.667a.667.667 0 0 0 0-1.333zM4 3.333h-.667a.667.667 0 0 0 0 1.333H4a.667.667 0 1 0 0-1.333zm3.333 0h-.666a.667.667 0 1 0 0 1.333h.667a.667.667 0 0 0 0-1.333zM4 6h-.667a.667.667 0 0 0 0 1.333H4A.667.667 0 1 0 4 6zm3.333 0h-.666a.667.667 0 1 0 0 1.333h.667A.667.667 0 0 0 7.333 6zM16 6.667v6A3.337 3.337 0 0 1 12.667 16H3.333A3.337 3.337 0 0 1 0 12.667V3.333A3.337 3.337 0 0 1 3.333 0h4a3.337 3.337 0 0 1 3.333 3.333h2A3.337 3.337 0 0 1 16 6.667zm-12.667 8h6V3.333a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v9.333a2 2 0 0 0 2 2zm11.333-8a2 2 0 0 0-2-2h-2v10h2a2 2 0 0 0 2-2zm-2 2a.667.667 0 1 0 .667.667.667.667 0 0 0-.666-.667zm0 2.667a.667.667 0 1 0 .667.667.667.667 0 0 0-.666-.668zm0-5.333a.667.667 0 1 0 .667.667.667.667 0 0 0-.666-.668z",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedEmployer);
export default __webpack_public_path__ + "static/media/detailed-employer.3577adf64d245a2fd649778e807f1adb.svg";
export { ForwardRef as ReactComponent };